import { useMutation } from "react-query";
import http from "infra/http";
import { AxiosError } from "axios";

function useCriarMarcaEquipamento() {
  return useMutation<
    {id: string},
    AxiosError,
    string
  >(
    async (nome: string) => {
      const {data} = await http.post<{id: string}>(`/v1/marca-equipamento/`, {
        nome
      });

      return data;
    },
    { retry: false }
  );
}

export default useCriarMarcaEquipamento;
